import { useMutation } from '@tanstack/react-query'
import { postJSON } from '@/lib/api'

interface CheckoutResponse {
  checkout_session?: { checkout_url: string }
}

export function useGiveCheckout({
  name,
  email,
  amount,
  campaignId,
  feeCover,
  tributeType,
  honoreeName,
  displayAnonymous,
  verificationToken,
}: {
  name: string
  email: string
  amount: string
  campaignId: string
  feeCover: boolean
  tributeType: 'honor' | 'memory' | null
  honoreeName: string
  displayAnonymous: boolean
  verificationToken: string | null
}) {
  return useMutation<CheckoutResponse>({
    mutationFn: () =>
      postJSON<CheckoutResponse>('/api/v1/give/checkouts', {
        donation: {
          name,
          email,
          amount,
          campaign_id: campaignId || null,
          fee_cover: feeCover,
          tribute_type: tributeType,
          honoree_name: tributeType ? honoreeName || null : null,
          display_anonymous: displayAnonymous,
          idempotency_key: `give-${Date.now()}`,
          website: '',
          contact_verification_token: verificationToken,
        },
      }),
    onSuccess: (data) => {
      if (data.checkout_session?.checkout_url)
        window.location.assign(data.checkout_session.checkout_url)
    },
  })
}
